import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Register from '../pages/Register';
import Dashboard from '../pages/Dashboard';
// import BillingUsage from '../pages/BillingUsage';
// import KnowledgeBase from '../pages/KnowledgeBase/index';
import Conversation from '../pages/Conversations/index';
import Voices from '../pages/Voices';
// import TestZone from '../pages/TestZone';
import Integration from '../pages/Integration/Integration';
import Widget from '../pages/Widget';
import TokenLogin from '../pages/TokenLogin';
import Agent from '../pages/KnowledgeBase/Agent';
import KnowledgeBaseOverview from '../pages/KnowledgeBase/Overview';
import Users from '../pages/Users';
import Agency from '../pages/Agency';
import AgencyDetails from '../pages/AgencyDetails';
import AllConversations from '../pages/AllConversations';
import PackageLogs from '../pages/PackageLogs';
import TermsAndConditions from '../pages/TermsAndConditions';
import AllPackages from '../pages/AllPackages';
import Events from '../pages/Events';
import ChangePassword from '../pages/ChangePassword';
import AllPrompt from '../pages/AllPrompt';
import GlobalPrompt from '../pages/GlobalPrompt';
import Emails from '../pages/Emails';

function PrivateRoute({ children }) {
  const isLoggedIn = !!localStorage.getItem('token');
  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/token-login" element={<TokenLogin />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/brands" element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route path="/allconversation" element={<PrivateRoute><AllConversations /></PrivateRoute>} />
        <Route path="/agency" element={<PrivateRoute><Agency /></PrivateRoute>} />
        <Route path="/agencydetails" element={<PrivateRoute><AgencyDetails /></PrivateRoute>} />
        <Route path="/package-logs" element={<PrivateRoute><PackageLogs /></PrivateRoute>} />
        <Route path="/all-packages" element={<PrivateRoute><AllPackages /></PrivateRoute>} />
        <Route path="/user-prompt" element={<PrivateRoute><AllPrompt /></PrivateRoute>} />
        <Route path="/global-prompt-settings" element={<PrivateRoute><GlobalPrompt /></PrivateRoute>} />
        <Route path="/knowledge-base" element={<PrivateRoute><KnowledgeBaseOverview /></PrivateRoute>} />
        <Route path="/agent" element={<PrivateRoute><Agent /></PrivateRoute>} />
        <Route path="/conversations" element={<PrivateRoute><Conversation /></PrivateRoute>} />
        <Route path="/events" element={<PrivateRoute><Events /></PrivateRoute>} />
        <Route path="/voices" element={<PrivateRoute><Voices /></PrivateRoute>} />
        {/* <Route path="/test-zone" element={<PrivateRoute><TestZone /></PrivateRoute>} /> */}
        <Route path="/integration" element={<PrivateRoute><Integration /></PrivateRoute>} />
        <Route path="/emails" element={<PrivateRoute><Emails /></PrivateRoute>} />

        {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
        <Route path="/terms-and-conditions" element={<PrivateRoute><TermsAndConditions /></PrivateRoute>} />
       {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
        {/* <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/ecommerce-setup" element={<PrivateRoute><EcommerceSetup /></PrivateRoute>} />
        <Route path="/email-setup" element={<PrivateRoute><EmailSetup /></PrivateRoute>} /> */}
        {/* <Route path="/billing-usage" element={<PrivateRoute><BillingUsage /></PrivateRoute>} /> */}
        {/* <Route path="/billing-usage" element={<PrivateRoute><Billing /></PrivateRoute>} />
        <Route path="/payment-method" element={<PrivateRoute><Billing /></PrivateRoute>} />
        <Route path="/basic-setup" element={<PrivateRoute><BasicSetup /></PrivateRoute>} /> */}
        <Route path="/widget" element={<PrivateRoute><Widget /></PrivateRoute>} />
        <Route path="/change-password/:userId" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
        {/* <Route path="/insights" element={<PrivateRoute><Insights /></PrivateRoute> /> */}
        
        <Route path="/" element={<TokenLogin />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default AppRoutes;
